import { Component, OnDestroy, OnInit } from '@angular/core';
import { AudioPlayerService } from '../../../services/audio-player.service';

@Component({
  selector: 'app-button-liedje',
  templateUrl: './button-liedje.component.html',
  styleUrls: ['./button-liedje.component.less']
})
export class ButtonLiedjeComponent implements OnInit, OnDestroy {

  constructor(public audio: AudioPlayerService) {

  }
  ngOnDestroy(): void {
    // Stop the music when the component is destroyed
    this.audio.stopMusic();
  }

  ngOnInit(): void {

  }
  play() {
    this.audio.playMusic();
  }
}
